import BaseModel from "../../BaseModal"

const MessageModal = (props) => {
    return (
        <BaseModel closeModal={props.closeModal}>
            <div>
                <p>{props.message}</p>
            </div>
        </BaseModel>
    )
}

export default MessageModal